import { axiosInstance } from "@/services/axiosInstance";
import store from "@/store";

export const UsuarioResource = {
  autenticar: parametros => {
    return axiosInstance.post("v1/user/authenticate", parametros);
  },

  register: parametros => {
    return axiosInstance.post("v1/user/register", parametros);
  },

  forgotPassword: parametros => {
    return axiosInstance.post("v1/user/forgot-password", parametros);
  },

  resetPassword: parametros => {
    return axiosInstance.put("v1/user/reset-password", parametros);
  },

  getUsersBySaleChannel: parametros => {
    return axiosInstance.get("v1/user/byparentuser", {
      params: parametros
    });
  },

  getCommissioner: parametros => {
    return axiosInstance.get("v1/user/commissioner", {
      params: parametros
    });
  },

  generatePassword: parametros => {
    return axiosInstance.put("v1/user/generate-password", parametros);
  },

  confirmEmail: parametros => {
    return axiosInstance.post("v1/user/confirm-email", parametros);
  },

  confirmPasswordReset: parametros => {
    return axiosInstance.put("v1/user/reset-password", parametros);
  },

  logout: () => {
    store.dispatch("logout");
  },

  get: parametros => {
    return axiosInstance.get("v1/user", {
      params: parametros
    });
  },

  getByParentUser: parametros => {
    return axiosInstance.get("v1/user/byparentuser", {
      params: parametros
    });
  },

  getManager: () => {
    return axiosInstance.get("v1/user/manager");
  },

  getCoordinator: () => {
    return axiosInstance.get("v1/user/coordinator");
  },
  getSupervisor: () => {
    return axiosInstance.get("v1/user/supervisor");
  },
  getRepresentative: () => {
    return axiosInstance.get("v1/user/representative");
  },
  getSalesman: () => {
    return axiosInstance.get("v1/user/salesman");
  },

  getUserWithBankAccount: (parametros, urlParams) => {
    return axiosInstance.get("/api/v1/user/:id/withbankaccount", {
      params: parametros,
      urlParams
    });
  },

  updateUser: (parametros, urlParams) => {
    return axiosInstance.put(`/api/v1/user/${urlParams.id}`, parametros);
  },

  updateUserWithBankAccount: (parametros, urlParams) => {
    return axiosInstance.put(`/api/v1/user/${urlParams.id}/withbankaccount`, parametros);
  }
};
